import { useEffect } from 'react';
import { Star } from 'lucide-react';
import { FaGoogle } from 'react-icons/fa';
import { useContent } from '@/lib/content';
import { Reveal } from '@/components/Reveal';
import { Navbar } from '@/components/Navbar';
import { Footer } from '@/components/Footer';
import { WhatsAppFloat } from '@/components/WhatsAppFloat';

export default function TestimonialsPage() {
  const { testimonials, loaded } = useContent();

  useEffect(() => {
    document.title = 'Client Reviews | Events by AJ — 5-Star Event Planner in Hyderabad';
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-ink text-cream min-h-screen">
      <div className="grain-overlay" aria-hidden="true" />
      <Navbar />
      <main className="pt-28 sm:pt-36 pb-24">
        <div className="max-w-7xl mx-auto px-5 sm:px-8">
          <Reveal>
            <p className="caption-label mb-4">Kind Words</p>
            <h1 className="font-serif text-4xl sm:text-5xl md:text-6xl font-light tracking-tight text-cream">
              Loved by families <span className="italic text-champagne">across Hyderabad</span>
            </h1>
            <div className="mt-6 flex items-center gap-3">
              <FaGoogle size={20} className="text-cream" />
              <span className="flex text-champagne">
                {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="currentColor" />)}
              </span>
              <span className="text-sm text-white/60 font-light">5.0 rating on Google — 100+ reviews</span>
            </div>
          </Reveal>

          {loaded && (
            <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10" data-testid="testimonials-grid">
              {testimonials.map((t, i) => (
                <Reveal key={t.name + i} delay={(i % 3) * 0.08} className="bg-ink p-8 flex flex-col hover:bg-surface transition-colors duration-500">
                  <span className="flex text-champagne mb-6">
                    {[...Array(5)].map((_, s) => <Star key={s} size={14} fill="currentColor" />)}
                  </span>
                  <p className="font-serif text-xl font-light text-cream/90 leading-relaxed italic flex-1">&ldquo;{t.review}&rdquo;</p>
                  <div className="mt-8 pt-6 border-t border-white/10 flex items-center gap-4">
                    <span className="w-11 h-11 rounded-full bg-champagne/15 border border-champagne/40 flex items-center justify-center font-serif text-champagne text-sm">
                      {t.initials}
                    </span>
                    <div>
                      <p className="text-cream text-sm font-medium tracking-wide">{t.name}</p>
                      <p className="text-[11px] uppercase tracking-[0.25em] text-white/40 mt-0.5">{t.event}</p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          )}

          <Reveal className="mt-16 text-center">
            <p className="font-serif text-2xl sm:text-3xl font-light text-cream">Planning Your Next Event?</p>
            <a data-testid="testimonials-page-enquire" href="/#enquiry" className="btn-gold mt-6 inline-flex">Let&rsquo;s Make It Unforgettable</a>
          </Reveal>
        </div>
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
